export default __webpack_public_path__ + "static/media/img2.2862ff87.jpg";